
import { defineComponent } from "vue";
import Heading5 from "@/components/headings/Heading5.vue";

export default defineComponent({
  name: "ProgressBar",
  components: {
    Heading5,
  },
  props: ["width", "content"],
});
